<template>
    <div class="pricing-plan-features">
        <ul :class="{'list-popular': isPopularPlan}">
            <li v-for="(itemVal, itemKey) in mutatedFeatures" :key="itemKey" :class="{'field-disabled': itemVal.disabled}">
                <i :class="['far', itemVal.disabled ? 'fa-times' : 'fa-check']"></i>
                <span v-html="itemVal.name"></span>
                <a-tooltip v-if="itemVal.tooltip" :prefixCls="$prefixClass.tooltip" overlayClassName="pricing-plan-features__tooltip"
                    placement="rightTop"
                >
                    <div slot="title" v-html="itemVal.tooltip"></div>
                    <i class="far fa-question-circle cursor-pointer m-l-6"></i>
                </a-tooltip>
            </li>
        </ul>
        <slot name="facts"></slot>
    </div>
</template>
<script>
    var randomID = () => {
        return String(Math.floor(Math.random() * 10000) + 1)
    }
    export default {
        name: 'pricing-plan-features',
        props: {
            features: {
                type: Array,
                default: () => []
            },
            isPopularPlan: Boolean
        },
        computed: {
            mutatedFeatures() {
                var features = {}
                return this.features
            }
        },
        methods: {
            getPopupContainer(elementID) {
                return () => document.getElementById(elementID)
            }
        }
    }
</script>
<style lang="scss">
    .pricing-plan-features {
        .list-popular {
            .fa-check {
                color: $white-color;
            }
        }
        > ul {
            text-align: left;
            .fa-times {
                font-weight: normal;
            }
            .fa-check {
                color: #2f43d7;
            }
            .fa-check, .fa-times {
                margin-right: 12px;
                font-size: 16px;
            }
            li {
                align-items: baseline !important;
                padding: 10px 0;
                margin-bottom: 8px;
            }
        }
        &__include {
            i {
                color: $success-color !important;
            }

            a.a-link {
                text-decoration: none;
                cursor: default;
            }
        }
        &__tooltip {
            .m-tooltip {
                &-content {
                    min-width: 322px;
                }
                &-inner {
                    padding: 6px 14px;
                }
            }
        }
    }
</style>
